/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-09-09 16:29:43
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  pleaseSelectATaskStatus: 'Please Select a Task Status',
  searchAssetName: 'Search Asset Name',
  pleaseChooseTheType: 'Please Choose the Type',
  createStartTime: 'Create Start Time',
  createEndTime: 'Create End Time',
  lastModifiedStartTime: 'Last Modified Start Time',
  lastModifiedEndTime: 'Last Modified End Time',
  assetName: 'Asset Name',
  schedule: 'Schedule',
  creationTime: 'Creation Time',
  lastModified: 'Last Modified',
  theCompletedPdfFileConversionOcrTypeCanNoLongerBeOperated:
    'The Completed Pdf File Conversion Ocr Type can No Longer be Operated!',
  thisOperationWillBeBatched: 'This Operation will be Batched',
  thisOperationWillBe: 'This Operation will be',
  whetherToContinue: 'Whether to Continue',
  pleaseTickRequired: 'Please Tick Required',
  item: 'Item',
  conversionNotCompleteWaitAMoment: 'Conversion Not Complete, Wait A Moment',
  pleaseSelectTheDataToDelete: 'Please Select The Data To Delete',
  theSelectedDataContainsDataWithAStatusOtherThanFailed:
    'The Selected Data Contains Data With A Status Other Than Failed',
  operationWillPermanentlySelectTheDataWhetherToContinue:
    'This Operation will Permanently Select The Data, Whether to Continue',
  successfullyDeleted: 'Successfully Deleted',
  ParsingTheModelInformationObject: 'Parsing the model information object',
}
